// Wideo: po kliknięciu "Zobacz" plakat zamieniany jest na odtwarzacz (YouTube, Vimeo lub plik wideo)
function embedUrl(url) {
    const youtube = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/),
        vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);

    if (youtube) {
        return 'https://www.youtube-nocookie.com/embed/' + youtube[1] + '?autoplay=1&rel=0';
    }
    if (vimeo) {
        return 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
    }

    return '';
}

function play(container) {
    const url = container.dataset.video;
    let player;

    if (/\.(mp4|webm|ogg)(\?|$)/i.test(url)) {
        player = document.createElement('video');
        player.src = url;
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
    } else {
        const src = embedUrl(url);
        if (!src) {
            return;
        }
        player = document.createElement('iframe');
        player.src = src;
        player.allow = 'autoplay; fullscreen; picture-in-picture';
        player.allowFullscreen = true;
        player.title = 'Wideo';
    }

    player.className = 'video__frame';
    container.appendChild(player);
    container.classList.add('is-playing');
}

function init() {
    document.querySelectorAll('[data-video-play]').forEach((button) => {
        button.addEventListener('click', () => play(button.closest('[data-video]')));
    });
}

export default {init};
